export const SCHEDULE_TYPE = {
  DEMO: 'DEMO',
  REGULAR: 'REGULAR',
  BACKUP: 'BACKUP',
  SUPPORT_TECHNICAL: 'SUPPORT_TECHNICAL',
  VIP_DEMO: 'VIP_DEMO',
  VIP_REGULAR: 'VIP_REGULAR'
  // HYBRID_REGULAR_OFFLINE: 'HYBRID_REGULAR_OFFLINE',
  // HYBRID_REGULAR_ONLINE: 'HYBRID_REGULAR_ONLINE',
  // HYBRID_BACKUP_OFFLINE: 'HYBRID_BACKUP_OFFLINE',
  // HYBRID_BACKUP_ONLINE: 'HYBRID_BACKUP_ONLINE'
}

export const SCHEDULE_TYPE_BASE = {
  DEMO: 'DEMO',
  REGULAR: 'REGULAR',
  BACKUP: 'BACKUP'
}

export const SCHEDULE_TYPE_BASE_SORT = {
  REGULAR: 'REGULAR',
  DEMO: 'DEMO',
  BACKUP: 'BACKUP'
}
export const SCHEDULE_STATUS = {
  OPEN: 'OPEN',
  ASSIGNED: 'ASSIGNED',
  ASSIGNED_BACKUP: 'ASSIGNED_BACKUP',
  CONFIRMED_BACKUP: 'CONFIRMED_BACKUP',
  CONFIRMED: 'CONFIRMED',
  CANCELED: 'CANCELED',
  WAITING_CANCELLATION_CONFIRMATION: 'WAITING_CANCELLATION_CONFIRMATION',
  MONITOR_BACKUP: 'MONITOR_BACKUP'
}

export const SCHEDULE_STATUS_NEW = {
  OPEN: 'OPEN',
  ASSIGNED: 'ASSIGNED',
  WAITING_CANCELLATION_CONFIRMATION: 'WAITING_CANCELLATION_CONFIRMATION',
  MONITOR_BACKUP: 'MONITOR_BACKUP',
  SCHEDULE_KEEPING: 'SCHEDULE_KEEPING'
}

export const MODEL_SCHEDULE_DEMO = [SCHEDULE_TYPE.DEMO, SCHEDULE_TYPE.VIP_DEMO]

export const STUDY_PROGRAM_DEMO = ['EDUPIA_VIP_DEMO_SP', 'EDUPIA_VIP_DEMO_GR', 'EDUPIA_VIP_DEMO_GE', 'EDUPIA_TUTOR_DEMO']
export const STUDY_PROGRAM_DEMO_VIP = ['EDUPIA_VIP_DEMO_SP', 'EDUPIA_VIP_DEMO_GR', 'EDUPIA_VIP_DEMO_GE']

export const SCHEDULE_TYPE_TIME_TABLE = ['REGULAR', 'BACKUP','DEMO']

export const SCHEDULE_TYPE_REGULAR_DEMO = ['REGULAR','DEMO']
